import type { BlockExport } from "@/react/components/shared/BuilderUI/BuilderUI.types";
import { FormNumberBlock as Block } from "./FormNumberBlock";
import { defaultData } from "./FormNumberBlockDefaultData";
import { meta } from "./FormNumberBlockMetaData";

export const FormNumberBlock: BlockExport = {
  type: "component",
  Block,
  defaultData,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-number",
    size: 24,
  },
  meta,
};
